import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { applyOpacity } from '../../utils/color.utils';
import HBText from '../HBText/HBText';

export const ThumbnailsWrapper = styled.ul`
    display: flex;
    flex-wrap: wrap;
    row-gap: 5px;
    padding: 0;
    margin: 0;
`;

export const ThumbnailBody = styled.div`
    display: flex;
    padding: 8px;
    flex-direction: column;
    flex: 4;
`;

export const ThumbnailActions = styled.div<{ hasDeleteButton: boolean }>`
    display: none;
    background-color: ${applyOpacity(
        vars.colors.surface.containerInverted,
        70
    )};
    padding: 5px;
    position: relative;
`;

export const Button = styled.a`
    font-size: 14px;
    color: ${vars.colors.text.secondary};
    transition: color 0.25s ease;
`;

export const ButtonWrapper = styled.div`
    height: 30px;
    width: 30px;
    background-color: ${vars.colors.surface.neutral};
    border-radius: ${vars.radius.full};
    padding-top: 6px;
    padding-left: 8px;

    &:hover ${Button} {
        color: ${vars.colors.text.primary};
    }
`;

export const ThumbnailImage = styled.img`
    width: 100px;
    height: 58px;
    margin: 0 auto;
`;

export const ThumbnailFileName = styled(HBText)`
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 90px;
    white-space: nowrap !important;
`;

export const ThumbnailImageContainer = styled.div`
    background-color: ${vars.colors.surface.itemInset};
    display: flex;
    flex: 3;
`;

export const ThumbnailWrapper = styled.li<{
    isSelectable: boolean;
    isSelected: boolean;
    isUploading: boolean;
}>`
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 0 7px 2px 0;
    width: 100px !important;
    height: 140px;
    background: ${vars.colors.surface.item};
    box-shadow: ${vars.shadow['10']};
    transition: opacity 0.15s ease;
    cursor: pointer;

    :hover {
        box-shadow: ${vars.shadow['30']};
    }

    ${({ isSelected }) =>
        isSelected &&
        css`
            border: 2px ${vars.colors.stroke.selected} outset !important;
            box-shadow: none !important;
            opacity: 0.6;
        `}

    ${({ isUploading }) =>
        isUploading &&
        css`
            opacity: 0.4;
            filter: alpha(opacity=0.4);
            pointer-events: none;
        `}
    
    &:hover {
        ${ThumbnailActions} {
            display: flex;
        }
    }
`;

export const SelectedFileBox = styled.span<{ visible: boolean }>`
    visibility: hidden;
    position: absolute;

    ${({ visible }) =>
        visible &&
        css`
            display: flex;
            justify-content: center;
            align-items: center;
            color: ${vars.colors.text.invertedPrimary};
            background: ${vars.colors.surface.containerInverted};
            border-bottom-left-radius: 3px;
            box-shadow: ${vars.shadow['20']};
            width: 25px;
            height: 25px;
            font-weight: bold;
            font-size: 15px;
            visibility: visible;
            top: 0;
            right: 0;
        `}
`;
